module.exports = __webpack_public_path__ + "img/MENU-AI.389f7f95.gif";